import { Button } from '../ui/button';
import { ReactNode } from 'react';

interface TopBarTitleIconButton {
  title: string;
}

export function TopBarTitle({
  title,
}: TopBarTitleIconButton) {
  return (
    <>
      {/* Spacer to reserve space in document flow — must match fixed header height */}
      <div className="shrink-0 safe-top">
        <div className="h-16" />
      </div>
      {/* Fixed header */}
      <div className="bg-surface-brand-L0 fixed top-0 left-0 right-0 z-50 safe-top">
        <div className="content-frame px-gutter py-4 flex items-center justify-between">
        <h1 className="text-content-primary-bold text-xl font-semibold">
          {title}
        </h1>
        </div>
      </div>
    </>
  );
}
